var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconIndependentCornersRadius24 = function SvgIconIndependentCornersRadius24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.02 4.666h2.75c1.434 0 2.6 1.166 2.6 2.6v2.72h-1.7v-2.72c0-.496-.405-.9-.9-.9h-2.75v-1.7ZM4.665 7.236c0-1.435 1.165-2.6 2.6-2.6h2.72v1.7h-2.72c-.496 0-.9.404-.9.9v2.75h-1.7v-2.75ZM4.635 16.735v-2.72h1.7v2.72c0 .496.404.9.9.9h2.75v1.7h-2.75a2.602 2.602 0 0 1-2.6-2.6ZM19.335 14.015v2.75c0 1.434-1.166 2.6-2.6 2.6h-2.72v-1.7h2.72c.495 0 .9-.404.9-.9v-2.75h1.7Z",
    fill: "current"
  })));
};
export default SvgIconIndependentCornersRadius24;